// extracted by mini-css-extract-plugin
export default {"content":"about_content__vTQI6","title":"about_title__kQtPG"};